import type { PricingGap } from '@models/price-list-completeness';

/** One line of the hover card: which grid is short, by how much, and where to go to fill it in. */
export interface CompletenessGapRow {
  /** Stable key for the template's `@for` track. */
  key: string;
  label: string;
  missingCount: number;
  expectedCount: number;
  /** Router link to the unit's form, or null for the water-level grids — they are on this page already. */
  link: unknown[] | null;
}

/**
 * What the indicator shows:
 * <ul>
 *   <li>`unknown` — completeness has not been read (or the read failed): show nothing rather than a
 *   green tick the data does not support;</li>
 *   <li>`not-priceable` — the lake has no grid to fill at all (no seasons or stay types configured, no
 *   capacity anywhere). Nothing is missing because nothing is expected; the Season periods card is
 *   where that is said, so this shows nothing either;</li>
 *   <li>`complete` / `incomplete` — the real answer.</li>
 * </ul>
 */
export type CompletenessState = 'unknown' | 'not-priceable' | 'complete' | 'incomplete';

/** The link for a gap, or null when the grid lives on the Pricing tab itself. */
export function gapLink(gap: PricingGap, waterId: number): unknown[] | null {
  if (gap.unitId === null) return null;
  const segment = gap.kind === 'fishing-spot' ? 'spots' : 'accommodations';
  return ['/waters/edit', waterId, segment, 'edit', gap.unitId];
}
